import { render } from "./Index2.vue?vue&type=template&id=5aa869dc"
import script from "./Index2.vue?vue&type=script&lang=js"
export * from "./Index2.vue?vue&type=script&lang=js"

import "./Index2.vue?vue&type=style&index=0&id=5aa869dc&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__